import { Drawer } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  TVCHANNEL_BOUQUETS,
  TVCHANNEL_BOUQUETS_CREATE,
  TVCHANNEL_BOUQUETS_EDIT,
  TVCHANNEL_BOUQUETS_VIEW,
  TVCHANNEL_CATEGORY,
  TVCHANNEL_CATEGORY_CREATE,
  TVCHANNEL_CATEGORY_EDIT,
  TVCHANNEL_CHANNELS,
  TVCHANNEL_CHANNELS_CREATE,
  TVCHANNEL_CHANNELS_EDIT,
  TVCHANNEL_CHANNELS_VIEW,
} from '../../../constants/TvChannelsConst';
import { validateUserSession } from '../../../utils/authUtils';
import { selectedHotelSelector } from '../../property/propertySlice';
import BouquetCreate from './bouquets/bouquets-create/Bouquets-Create';
import BouquetsList from './bouquets/bouquets-list/Bouquets-List';
import ChannelCreate from './channels/channel-create/Channel-Create';
import BouquetsView from './bouquets/bouquets-view/Bouquets-View';
import ChannelList from './channels/channel-list/Channel-List';
import CategoryCreate from './category/category-create/Category-Create';
import CategoryList from './category/category-list/Category-List';
import ChannelView from './channels/channel-view/Channel-View';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const TvChannels = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const classes = useStyles();
  const search = useLocation().search;
  const history = useHistory();
  const tabToOpen = new URLSearchParams(search).get('tab');
  const selectedHotel = useSelector(selectedHotelSelector);
  const [activeTab, setActiveTab] = useState(tabToOpen || TVCHANNEL_BOUQUETS);
  const [state, setState] = useState({
    type: TVCHANNEL_BOUQUETS_CREATE,
    status: false,
  });
  const [viewState, setViewState] = useState({
    type: TVCHANNEL_BOUQUETS_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  useEffect(() => {
    if (
      activeTab === TVCHANNEL_BOUQUETS ||
      activeTab === TVCHANNEL_CATEGORY ||
      activeTab === TVCHANNEL_CHANNELS
    ) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case TVCHANNEL_CATEGORY_CREATE:
        return (
          <CategoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            category={state.obj}
            showLoader={showLoader}
          />
        );
      case TVCHANNEL_CATEGORY_EDIT:
        return (
          <CategoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            category={state.obj}
            showLoader={showLoader}
          />
        );
      case TVCHANNEL_BOUQUETS_CREATE:
        return (
          <BouquetCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            bouquet={state.obj}
            showLoader={showLoader}
          />
        );
      case TVCHANNEL_BOUQUETS_EDIT:
        return (
          <BouquetCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            bouquet={state.obj}
            showLoader={showLoader}
          />
        );
      case TVCHANNEL_CHANNELS_CREATE:
        return (
          <ChannelCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case TVCHANNEL_CHANNELS_EDIT:
        return (
          <ChannelCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            channel={state.obj}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case TVCHANNEL_BOUQUETS_VIEW:
        return (
          <BouquetsView
            bouquet={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></BouquetsView>
        );
      case TVCHANNEL_CHANNELS_VIEW:
        return (
          <ChannelView
            channel={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          ></ChannelView>
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>TV Channels</span>
            </div>
            <div className='col-md-6 d-flex justify-content-end'></div>
          </div>
          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex flex-wrap'>
              <Button
                size='large'
                variant={activeTab === TVCHANNEL_BOUQUETS ? 'outlined' : 'text'}
                className={
                  activeTab === TVCHANNEL_BOUQUETS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(TVCHANNEL_BOUQUETS)}
              >
                Bouquets
              </Button>
              <Button
                size='large'
                variant={activeTab === TVCHANNEL_CATEGORY ? 'outlined' : 'text'}
                className={
                  activeTab === TVCHANNEL_CATEGORY
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(TVCHANNEL_CATEGORY)}
              >
                Category
              </Button>
              <Button
                size='large'
                variant={activeTab === TVCHANNEL_CHANNELS ? 'outlined' : 'text'}
                className={
                  activeTab === TVCHANNEL_CHANNELS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(TVCHANNEL_CHANNELS)}
              >
                Channels
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === TVCHANNEL_BOUQUETS && (
                <BouquetsList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  permissions={permissions}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === TVCHANNEL_CATEGORY && (
                <CategoryList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  permissions={permissions}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
              {activeTab === TVCHANNEL_CHANNELS && (
                <ChannelList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  permissions={permissions}
                  selectedHotel={selectedHotel}
                  state={state}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default TvChannels;
